export default __webpack_public_path__ + "static/media/AmazonElasticsearchService.49c21347.svg";